module.exports = __webpack_public_path__ + "img/cartao+sport.4185167b.png";